import { useState } from "react";
import { MinusIcon, PlusIcon } from "../../../assets/icons";
import "../Forms.scss";

function NumberInput({ name, value, initialValue = 0, onChange }) {
  const [internalValue, setInternalValue] = useState(initialValue);
  const isControlled = value !== undefined;
  const currentValue = isControlled ? value : internalValue;

  function handleUpdate(newValue) {
    if (!isControlled) {
      setInternalValue(newValue);
    }
    if (onChange) {
      onChange(newValue);
    }
  }

  function handleChange(e) {
    const vs = String(e.target.value).replace(/\D/g, "");
    const v = vs === "" ? 0 : parseInt(vs, 10);
    handleUpdate(v);
  }

  return (
    <div className="number-input">
      <button type="button" onClick={() => handleUpdate(currentValue + 1)}>
        <PlusIcon />
      </button>
      <input
        type="text"
        name={name}
        id={name}
        value={currentValue}
        onChange={handleChange}
      />
      <button
        type="button"
        onClick={() => {
          if (currentValue > 0) handleUpdate(currentValue - 1);
        }}
      >
        <MinusIcon />
      </button>
    </div>
  );
}

export default NumberInput;
